// src/components/ParallelogramRow.jsx
import React from "react";
import "./ParallelogramRow.css";

export default function ParallelogramRow({
    items,
    width = 280,
}) {
  return (
    <div className="parallelogram-row">
      {items.map((item, index) => (
        <div
          key={index}
          className={`parallelogram ${item.color}`}
          style={{
            width
          }}
        >
          <span>{item.text}</span>
        </div>
      ))}
    </div>
  );
}
